import { useEffect } from "react";

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    if (!title) {
      document.title = "哈希编程-PythonTip学编程";
    } else {
      document.title = title + "-哈希编程-PythonTip学编程";
    }
  }, [title]);
};

export default useDocumentTitle;
